import { Button, Grid, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DataTable from "../../../components/features/Datatable";
import Filter from "./Filter";
import BsModal from "../../../components/common/BaseModal";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getApprovedLSMListing } from "../../../slices/logisticSlice";
import {  filterConfigRecived } from "../../../utils/common/utils";
import InBoundForm from "../../../../pages/appointment-details/InBoundForm";
import { hasAuthority } from "../../../../utils/authorities";
import ChatModule from "../../Chat";
import { addPatientList, addPhaseList } from "../../../slices/chat";
import {capitalizeWords} from "../../../../utils/utils"
const ApprovalReceived = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedPatientData, setSelectedPatientData] = useState(null);
  const dispatch = useDispatch();
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const { approvedLSMList } = useSelector((state) => state.bmrLogistic);



  const handleCloseModal = () => {
    setOpen(false);
  };

  const updateFilter = (filter) => {
    fetchUsers(filter);
  };

  const fetchUsers = async (filter) => {
    await dispatch(getApprovedLSMListing(filter));
  };



  const columns = [
    {
      id: "subject_code",
      name: "Subject/Patient ID",
      selector: (row) => (row.subject_patient_id ? row.subject_patient_id : "N/A"),
      sortable: true,
    },
    {
      id: "subject_name",
      name: "Subject/Patient Name",
      selector: (row) => (row.subject_name ? capitalizeWords(row.subject_name) : "N/A"),
      sortable: true,
    },
    {
      id: "product_phase",
      name: "Product/Phase",
      selector: (row) =>
        row.product_name && row.phase_name
          ? `${(row.product_name)}/${capitalizeWords(row.phase_name)}`
          : "N/A",
      sortable: true,
    },
    {
      id: "phase_type",
      name: "Type",
      selector: (row) => (row.phase_type ? row.phase_type : "N/A"),
      sortable: true,
    },
    {
      id: "hospital_name",
      name: "Hospital/Site",
      selector: (row) => (row.hospital_name ? row.hospital_name : "N/A"),
      sortable: true,
    },
    {
      id: "disease",
      name: "Disease",
      selector: (row) => (row.disease ? row.disease : "N/A"),
      sortable: true,
    },
    {
      id: "lsm_status",
      name: "Status",
      selector: (row) =>
        row.lsm_status == 1 ? (
          <p className="text-[#00B278] font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">
            {'Approved'}
          </p>
        ) : (
          <p className="font-roboto font-normal text-[14px] leading-[100%] tracking-[0] text-[#FF2023]">
            {row?.lsm_status ? "Rejected" : "Pending"}
          </p>
        ),
      sortable: true,
    },
     { id: "stage", name: "Stage", selector: row => row.stage ? row.stage : "N/A", sortable: true },

        {
    id: "cycleObject", 
    name: "Cycle",
    selector: (row) => {
        if (row.cycleObject) {
            const cycleValue =  row.cycleObject;
            return (
                <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium border border-blue-300 whitespace-nowrap">
                    {cycleValue}
                </span>
            );
        }
        return "N/A";
    },
    sortable: true,
},
    {
      name: "Action",
      selector: (row) => (
        <Button
          onClick={() =>
            navigate(`/bmr/lsm-acceptance/approval-received/details/${row.qr_code_generated_id}/?batch=${row.batch_no}`,{
             state: [
            { name: "Approved LSM", path: location.pathname },
            {
              name: "Details",
              path: `/bmr/lsm-acceptance/approval-received/details/${row.qr_code_generated_id}/?batch=${row.batch_no}`,
            },
            ]
            })
          }
          key={row.qr_code_generated_id}
          size="small"
          className="!w-[100px]"
        >
          View Details
        </Button>
      ),
    },
  ];

  useEffect(() => {
    if (!open) setSelectedPatientData(null);
  }, [open]);


  ////////// phase and pantient List for chat bot ///////////

  useEffect(() => {
      const phaseList = approvedLSMList?.items?.map(op => { return { value: op?.phase_id, label: `${op?.phase_name} (${op?.product_name})`, patient_id: op?.subject_id } })
      const patientList = approvedLSMList?.items?.map(op => { return { value: op?.subject_id, label: `${op?.subject_name}`, phase_id: op?.phase_id } })
      dispatch(addPatientList(patientList))
      dispatch(addPhaseList(phaseList))
  }, [approvedLSMList])

  ////////////////////////////////////////////////////////////


  return (
    <Box>
      <Grid
        container
        className="mt-4 ml-0 mr-3 mainDiv"
        rowSpacing={4.5}
        columnSpacing={2.75}
      >
        <Grid item xs={12} sx={{ mt: -2.25 }}>
          {hasAuthority(['approval-received-listing'], bmr_permissions) && (
            <DataTable
              columns={columns}
              data={approvedLSMList}
              title="Subject/Patient"
              FilterComponent={Filter}
              onServerSideChange={updateFilter}
              filterConfig={filterConfigRecived}
              remote={true}
            />
          )}
        </Grid>
      </Grid>
      {open && (
        <BsModal open={open} onClose={handleCloseModal} size="lg">
          <InBoundForm
            patientData={{
              ...selectedPatientData,
              inbond_form_id: selectedPatientData?.inbound_patient_id,
              patient_id: selectedPatientData?.subject_id
            }}
            // printPatientInfo={selectedPatientData}
          />
        </BsModal>
      )}
      <ChatModule />
    </Box>
  );
};

export default ApprovalReceived;
